'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mountVue = mountVue;

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function mountVue(selector, rootComponent) {
  var el = document.querySelector(selector);
  if (el) {
    new _vue2.default({
      store: _store2.default,
      created: function created() {
        this.$store.dispatch('init');
      },

      render: function render(h) {
        return h(rootComponent, {});
      }
    }).$mount('' + selector);
    return true;
  } else {
    return false;
  }
}